import { isDefined } from "Utils/functions";
import React from "react";
import { ChipStyled } from "./chip.styled";

interface Props {
  chipText?: string;
}

export const Chip = ({ chipText }: Props): React.ReactElement | null => {
  if (!isDefined(chipText)) {
    return null;
  }

  return <ChipStyled>{chipText}</ChipStyled>;
};
